import { useLazyGetStopToolUrlQuery } from "@/shared/services";
import { Modal } from "@ab.uitools/ui-library/components/Modal";
import { Text } from "@ab.uitools/ui-library/components/Text";
import { useTranslation } from "react-i18next";

interface Props {
  content: {
    title: string;
    description: string;
  },
  isOpen: boolean;
  onClose: () => void;
}


export const AccessManagementDialog = ({ content, isOpen, onClose }: Props) => {
  const { t } = useTranslation();
  const [getUrl, { isFetching }] = useLazyGetStopToolUrlQuery();

  const handleSubmit = () => {
    getUrl().unwrap()
      .then((url) => {
        window.open(url, "_blank");
        onClose();
      });
  };

  return (
    <Modal
      closeIcon
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={handleSubmit}
      buttonProps={{
        confirm: {
          buttonText: t("general.manage"),
          isLoading: isFetching,
        },
        cancel: { buttonText: t("general.cancel") },
      }}
      titleProps={{
        title: t(content?.title),
        size: "large"
      }}
    >
      <Text>{t(content?.description)}</Text>
    </Modal>
  );
};
